// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"310c0f18","455":"9e32807a","977":"4f6221ed"}[chunkId] + ".chunk.js";
};